<template>
  <div clas="col-md-offset-2 col-xs-6 col-sm-6">
    <div class="c-pricingtable table-responsive">
      <p class="pb-base">
        <strong>Maandbedrag:</strong>
        {{ item.periodic_amount_quote_currency }}
      </p>
      <div class="c-pricingtable__inner">
        <div class="c-pricingtable__body">
          {{ item.description_contract_website }}
        </div>
      </div>
    </div>
    <div class="vx-col w-full mt-5 text-right">
      <vs-button @click="showDetails = true" color="primary" type="border"
        >Toon details</vs-button
      >
    </div>
    <vs-popup :title="item.contract_name_quote" :active.sync="showDetails">
      <table style="width:100%">
        <tr>
          <th>Omschrijving</th>
          <th class="text-right">Prijs per maand</th>
        </tr>
        <tr v-for="rule in item.quote_rules" :key="rule.$id">
          <td>{{ rule.omschrijving }}</td>
          <td class="text-right">
            <money-format
              v-if="rule.incl_totaal"
              :value="rule.incl_totaal"
              locale="nl"
              currency-code="EUR"
              :subunit-value="true"
              :hide-subunits="false"
            />
          </td>
        </tr>
        <tr>
          <th>Totaal per maand</th>
          <th class="text-right">
            {{ item.periodic_amount_quote_currency }}
          </th>
        </tr>
      </table>
    </vs-popup>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";

export default {
  components: {
    MoneyFormat
  },
  data() {
    return {
      showDetails: false,
      selectedStyle: {
        borderColor: "#1080d0"
      }
    };
  },
  props: ["item"],
  filters: {
    // you can call this whatever you want to
    formatQuantity(value) {
      return value.toLocaleString("nl-NL");
    }
  }
};
</script>
